import TextInput from '@unserkunde/enscompare-components/src/components/inputs/TextInput';

const RadioGroup = {
  defaultProps: {
    size: TextInput.defaultProps.size,
  },
  styles: (theme, params) => {
    const TextInputStyles = TextInput.styles(theme, params);
    return {
      radio: {
        ...TextInputStyles.input,
        '&:checked': {
          backgroundColor: theme.colors.primary[5],
          borderColor: theme.colors.primary[5],
        },
      },
    };
  },
};

export default RadioGroup;
